export enum EnvironmentNames {
  DEVELOPMENT = 'DEVELOPMENT',
  STAGING = 'STAGING',
  DEMO = 'DEMO',
  LHV_UK = 'LHV UK',
  LHV_EE = 'LHV EE',
  LHV_UK_UAT = 'LHV UAT',
  PRODUCTION = 'LIVE',
}

export interface Environment {
  name: EnvironmentNames;
  url: string;
  showLabel: boolean;
  hidePlatform: boolean;
  initializeIntercom: boolean;
  logoUrl?: string;
  cloudFlareSiteKey?: string;
}

const environments: Array<Environment> = [
  {
    name: EnvironmentNames.DEVELOPMENT,
    url: 'local',
    showLabel: true,
    hidePlatform: false,
    initializeIntercom: false,
  },
  {
    name: EnvironmentNames.STAGING,
    url: 'rms.salv.dev',
    showLabel: true,
    hidePlatform: false,
    initializeIntercom: false,
    cloudFlareSiteKey: '0x4AAAAAAAaTXqoEjY6y7h5N',
  },
  {
    name: EnvironmentNames.DEMO,
    url: 'demo.salv.com',
    showLabel: true,
    hidePlatform: false,
    initializeIntercom: true,
    cloudFlareSiteKey: '0x4AAAAAAAbTdX9szdBM85ht',
  },
  {
    name: EnvironmentNames.LHV_UK,
    url: 'hpn-xyck-she.salv.com',
    showLabel: true,
    hidePlatform: false,
    initializeIntercom: true,
  },
  {
    name: EnvironmentNames.LHV_EE,
    url: 'app.lhv-ee.salv.com',
    showLabel: true,
    hidePlatform: false,
    initializeIntercom: true,
  },
  {
    name: EnvironmentNames.LHV_UK_UAT,
    url: 'hpn-xyck-she-uat.salv.com',
    showLabel: true,
    hidePlatform: false,
    initializeIntercom: false,
  },
  {
    name: EnvironmentNames.PRODUCTION,
    url: 'app.salv.com',
    showLabel: false,
    hidePlatform: false,
    initializeIntercom: true,
    cloudFlareSiteKey: '0x4AAAAAAAbgQN7-R5WWwBoh',
  },
];

export const environmentName = (): string => window.location.host;
export const isOnPremise = (): boolean => environmentName().indexOf('salv.com') === -1;
export const isDevelopment = (): boolean => currentEnvironment()?.name === EnvironmentNames.DEVELOPMENT;

const detectedEnvironment = ((): Environment | null => {
  const currentEnvironmentName = environmentName();
  const environment = environments.find((env) => currentEnvironmentName.indexOf(env.url) !== -1);
  if (environment?.logoUrl) {
    const favicon = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
    favicon.href = environment.logoUrl;
  }
  return environment ?? null;
})();

export const currentEnvironment = () => detectedEnvironment;
